// Small UI primitives shared across the homepage.
export const Particles = () => (
  <div className="particles">
    {[...Array(9)].map((_, i) => (
      <div key={i} className="particle" />
    ))}
  </div>
);

export const AnimatedStat = ({ value, label }) => (
  <div className="text-center">
    <p className="text-3xl sm:text-4xl font-bold text-green-400 stat-animate">{value}</p>
    <p className="text-slate-400 text-sm">{label}</p>
  </div>
);

export const MatchSkeleton = () => (
  <div className="match-card animate-pulse">
    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
      <div className="flex-1">
        <div className="h-5 w-24 bg-slate-700 rounded mb-3"></div>
        <div className="h-6 w-48 bg-slate-700 rounded mb-2"></div>
        <div className="h-4 w-64 bg-slate-700 rounded mb-3"></div>
        <div className="h-4 w-32 bg-slate-700 rounded"></div>
      </div>
      <div className="h-12 w-40 bg-slate-700 rounded-full"></div>
    </div>
  </div>
);
